<span class="c-language-switcher-item">
  <span class="c-language-switcher-item__flag"><img class="c-language-switcher-item__flag-img" [src]="lang.flag" alt=""></span>
  <span class="c-language-switcher-item__name">{{ lang.name }}</span>
</span>
